import { SortKey, SortOrder, sortValues } from '../../../catalog';
import { Fragment } from 'react';

interface SortRowProps {
    sortBy: SortKey;
    sortOrder: SortOrder;
    onSortChange: (key: SortKey) => void;
}

function SortRow({ sortBy, sortOrder, onSortChange }: SortRowProps) {
    return (
        <div>
            <div>
                Сортировка:&nbsp;
                {Object.entries(sortValues).map(([key, name]) => (
                    <Fragment key={key}>
                        <span className="link" key={key} onClick={() => onSortChange(key as SortKey)}>
                            {name}
                            {sortBy === key && (sortOrder === SortOrder.Desc ? '↓' : '↑')}
                        </span>
                        &nbsp;
                    </Fragment>
                ))}
            </div>
        </div>
    );
}

export default SortRow;
